// Single source of truth for the LOCAL dev-preview layer (the dev launchpad and
// the locally-unhidden draft offerings). Everything in that layer keys off this.
//
// SAFETY: this is gated on process.env.NODE_ENV, which Create React App fixes at
// BUILD time — it is the literal 'production' in any `npm run build` output and
// 'development' only under `npm start`. So a deployed production bundle can never
// turn this on, regardless of any runtime/server env var. The hostname check is
// extra belt-and-suspenders so it stays local-only even in a dev build.
//
// Do NOT rewrite this to read a runtime-settable variable — that would defeat the
// guarantee that none of the dev-preview layer can appear in production.
export function isDevPreview() {
	if (process.env.NODE_ENV !== 'development') return false;
	if (typeof window === 'undefined') return true; // non-browser (tests/SSR) dev
	const host = window.location.hostname;
	if (host === 'localhost' || host === '127.0.0.1' || host === '') return true;
	// Local device testing: a DEV build served over the LAN (e.g. a phone hitting
	// http://192.168.x.x:3000). These are private, non-routable address ranges and
	// this is still gated by NODE_ENV==='development' above — CRA bakes that to
	// 'production' in any `npm run build`, so a deployed bundle can never match.
	return /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3})$/.test(
		host
	);
}
